import image1 from "assets/images/main/image1.webp";
import image2 from "assets/images/main/image2.png";
import image3 from "assets/images/main/image3.webp";

import review0 from "assets/images/main/review0.webp";
import review1 from "assets/images/main/review1.webp";
import review2 from "assets/images/main/review2.webp";
import review3 from "assets/images/main/review3.webp";
import review4 from "assets/images/main/review4.webp";
import review5 from "assets/images/main/review5.webp";
import review6 from "assets/images/main/review6.webp";
import review7 from "assets/images/main/review7.webp";
import review8 from "assets/images/main/review8.webp";
import review9 from "assets/images/main/review9.webp";

import article1 from "assets/images/main/article1.webp";
import article2 from "assets/images/main/article2.webp";
import article3 from "assets/images/main/article3.webp";
import article4 from "assets/images/main/article4.webp";
import article5 from "assets/images/main/article5.webp";
import article6 from "assets/images/main/article6.webp";

export const CAROUSEL_PROJECT_SLIDES = [
  {
    image: image1,
    caption: [
      <span>Мои проекты </span>,
      "— место, где собраны все ваши заказы и сценарии",
    ],
  },
  {
    image: image2,
    caption: [
      <span>Настраивайте проекты под себя </span>,
      "— выбирайте бюджет, время отправления заданий и соотношение действий в цепочке",
    ],
  },
  {
    image: image3,
    caption: [
      <span>Проверяйте отчеты исполнителей </span>,
      "— отклоняйте, если видите некачественную работу",
    ],
  },
];

export const CAROUSEL_REVIEWS_SLIDES = [
  { image: review0 },
  { image: review1 },
  { image: review2 },
  { image: review3 },
  { image: review4 },
  { image: review5 },
  { image: review6 },
  { image: review7 },
  { image: review8 },
  { image: review9 },
];

export const CAROUSEL_ARTICLES_SLIDES = [
  { image: article1, link: "https://dzen.ru/video/watch/67b870ae0135093deae58f1d?share_to" },
  { image: article2, link: "https://dzen.ru/a/ZvaNOdjJzx8i6wiR" },
  { image: article3, link: "https://dzen.ru/a/ZvFK1xXEwgQWgEHB" },
  { image: article4, link: "https://dzen.ru/a/Zs8n7VlNKgSQKWOh" },
  { image: article5, link: "https://dzen.ru/a/ZsowIjQxolGuY6mU" },
  { image: article6, link: "https://dzen.ru/a/Zrcj_QGeZVMCAlow" },
];
